export const hideWhenReadOnlyRule = {
    id: 'hideWhenReadOnly',
    description: 'Knappen döljs när formuläret är readOnly. (ex. i någon annan inkorg)',
    evaluateState: (row, inca, ctx)=>{
        if (ctx.errand.isReadOnly) {
            return {
                state: 'Hidden'
            };
        }
        return {
            state: 'Visible'
        };
    }
};
export const hideForReporterRule = {
    id: 'hideForReporter',
    description: 'Knappen döljs om användaren är inrapportör.',
    evaluateState: (row, inca)=>{
        if (!inca.user.role.isReviewer) {
            return {
                state: 'Hidden'
            };
        }
        return {
            state: 'Visible'
        };
    }
};
